export default __webpack_public_path__ + "static/media/general.0d60bf90.svg";